<template>
    <div class="page-shell">
        <div class="page-panel">
        <ul>
            <li>Duplo clique dentro do retangulo adiciona nova maquina (sugetão para nome IP / TTY / especificações)</li>
            <li>Clicar com o direto do mouse em cima da maquina abre opções</li>
            <li>Após concluir clique em salvar Mapa de Rede</li>
        </ul>
        <canvas ref="canvas" @mousedown="startMovingRectangle" @mousemove="moveRectangle" @mouseup="stopMovingRectangle"
            @mouseleave="stopMovingRectangle" @dblclick="addRectangle" @contextmenu.prevent="openContextMenu"></canvas>
        <!-- <button @click="clearCanvas">Limpar</button> -->
        <!-- <button @click="saveRectangles">Salvar Configurações</button>
 -->
        <b-row>
            <b-col cols="12">
                <v-btn @click="saveRectangles" text x-large>
                    <v-icon>mdi-content-save</v-icon>Salvar Mapa de Rede
                </v-btn>

                <v-btn @click="loadRectangles" text x-large>
                    <v-icon>mdi-refresh</v-icon>Resetar Mapa de Rede original
                </v-btn>
            </b-col>
        </b-row>

        <ul v-if="contextMenu.visible" :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px' }"
            class="context-menu">
            <li @click="editRectangleText">Editar Texto</li>
            <li @click="changeRectangleColor">Mudar Cor</li>
            <li @click="deleteRectangle">Excluir</li>
        </ul>
        </div>
    </div>
</template>

<script>
import ExecutaSQL from '../domain/ExecutaSQL';
import Vue from "vue";
export default {
    props: ["dados", "id_cliente"],
    data() {
        return {
            isDragging: false,
            ctx: null,
            rectangles: [],
            selectedRectangle: null,
            offsetX: 0,
            offsetY: 0,
            contextMenu: { visible: false, x: 0, y: 0, selectedRectangle: null },
            screenWidth: window.innerWidth,
        };
    },
    watch: {
        id_cliente: function (val) {
            console.log("id_cliente", val);
            this.loadRectangles();
        }


    },
    mounted() {


        const canvas = this.$refs.canvas;
        canvas.width = this.screenWidth - 150;
        canvas.height = 500;
        this.ctx = canvas.getContext("2d");
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = "black";
    },
    methods: {
        addRectangle(event) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            const label = prompt("Digite o texto:", "Novo Retângulo");

            if (label !== null) {
                const lines = this.wrapText(label, 100);
                const height = lines.length * 20 + 20;

                const newRectangle = {
                    x,
                    y,
                    width: 150,
                    height,
                    label,
                    lines,
                    color: "silver"
                };

                this.rectangles.push(newRectangle);
                this.redrawCanvas();
            }
        },
        startMovingRectangle(event) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            this.selectedRectangle = this.rectangles.find(r =>
                x >= r.x && x <= r.x + r.width &&
                y >= r.y && y <= r.y + r.height
            );

            if (this.selectedRectangle) {
                this.isDragging = true;
                this.offsetX = x - this.selectedRectangle.x;
                this.offsetY = y - this.selectedRectangle.y;
            }
        },
        moveRectangle(event) {
            if (!this.isDragging || !this.selectedRectangle) return;
            const rect = this.$refs.canvas.getBoundingClientRect();
            const x = event.clientX - rect.left - this.offsetX;
            const y = event.clientY - rect.top - this.offsetY;

            this.selectedRectangle.x = x;
            this.selectedRectangle.y = y;
            this.redrawCanvas();
        },
        stopMovingRectangle() {
            this.isDragging = false;
            this.selectedRectangle = null;
        },
        wrapText(text, maxWidth) {
            const words = text.split(" ");
            const lines = [];
            let currentLine = words[0];

            this.ctx.font = "12px Arial";

            for (let i = 1; i < words.length; i++) {
                const testLine = currentLine + " " + words[i];
                const metrics = this.ctx.measureText(testLine);

                if (metrics.width > maxWidth) {
                    lines.push(currentLine);
                    currentLine = words[i];
                } else {
                    currentLine = testLine;
                }
            }
            lines.push(currentLine);
            return lines;
        },
        openContextMenu(event) {
            event.preventDefault();
            const rect = this.$refs.canvas.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            this.contextMenu.selectedRectangle = this.rectangles.find(r =>
                x >= r.x && x <= r.x + r.width &&
                y >= r.y && y <= r.y + r.height
            );

            if (this.contextMenu.selectedRectangle) {
                this.contextMenu.visible = true;
                this.contextMenu.x = event.clientX;
                this.contextMenu.y = event.clientY - rect.top;
            }
        },
        editRectangleText() {
            if (this.contextMenu.selectedRectangle) {
                const newText = prompt("Edite o texto:", this.contextMenu.selectedRectangle.label);
                if (newText !== null) {
                    this.contextMenu.selectedRectangle.label = newText;
                    this.contextMenu.selectedRectangle.lines = this.wrapText(newText, 150);
                    this.contextMenu.selectedRectangle.height = this.contextMenu.selectedRectangle.lines.length * 20 + 20;
                    this.redrawCanvas();
                }
            }
            this.contextMenu.visible = false;
        },
        changeRectangleColor() {
            if (this.contextMenu.selectedRectangle) {
                this.contextMenu.selectedRectangle.color = `hsl(${Math.random() * 360}, 100%, 75%)`;
                this.redrawCanvas();
            }
            this.contextMenu.visible = false;
        },
        deleteRectangle() {
            if (this.contextMenu.selectedRectangle && confirm("Tem certeza que deseja excluir este retângulo?")) {
                this.rectangles = this.rectangles.filter(r => r !== this.contextMenu.selectedRectangle);
                this.redrawCanvas();
            }
            this.contextMenu.visible = false;
        },
        redrawCanvas() {
            /*   const canvas = this.$refs.canvas;
              this.ctx.clearRect(0, 0, canvas.width, canvas.height);
              
              this.rectangles.forEach(rect => {
                this.ctx.fillStyle = rect.color || "lightblue";
                this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                this.ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
                this.ctx.fillStyle = "black";
                this.ctx.font = "16px Arial";
                
                rect.lines.forEach((line, index) => {
                  this.ctx.fillText(line, rect.x + 10, rect.y + 20 + index * 20);
                });
              }); */

            const canvas = this.$refs.canvas;
            this.ctx.clearRect(0, 0, canvas.width, canvas.height);

            this.rectangles.forEach(rect => {
                this.ctx.fillStyle = rect.color || "#d3d3d3";
                this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height - 0);
                this.ctx.strokeRect(rect.x, rect.y, rect.width, rect.height - 0);

                // Tela
                this.ctx.fillStyle = "#000";
                this.ctx.fillRect(rect.x + 10, rect.y + 10, rect.width - 20, rect.height - 20);

                // Base
                this.ctx.fillStyle = rect.color || "#d3d3d3";
                this.ctx.fillRect(rect.x + 30, rect.y + rect.height - 0, rect.width - 60, 10);
                this.ctx.strokeRect(rect.x + 30, rect.y + rect.height - 0, rect.width - 60, 10);

                this.ctx.fillStyle = "white";
                this.ctx.font = "12px Arial";
                rect.lines.forEach((line, index) => {
                    this.ctx.fillText(line, rect.x + 15, rect.y + 25 + index * 15);
                });
            });
        },
        saveRectangles() {
            var rectangulo = JSON.stringify(this.rectangles);
            var wsql =
                "UPDATE cliente SET mapa_rede='" + Vue.btoa(rectangulo) + "' " +
                " WHERE id = " + this.id_cliente;

            this.service = new ExecutaSQL(this.$resource);
            this.service.get(wsql).then(
                function (tmp) {
                    //this.entries = tmp;
                    //this.isLoading = false;
                    alert("Configurações salvas com sucesso!");
                },
                (err) => {
                    console.log(err);
                    //this.isLoading = false;
                }
            );

        },
        loadRectangles() {
            var wsql = "SELECT mapa_rede FROM cliente WHERE id = " + this.id_cliente;
            this.service = new ExecutaSQL(this.$resource);
            this.service.get(wsql).then(
                function (tmp) {
                    if (tmp.length > 0) {
                        if (tmp[0].mapa_rede != null && tmp[0].mapa_rede != '') {
                            this.rectangles = JSON.parse(Vue.atob(tmp[0].mapa_rede));
                            this.redrawCanvas();
                        } else {
                            this.clearCanvas();
                        }
                    }
                },
                (err) => {
                    this.clearCanvas();
                    console.log(err);
                }
            );
        },
        clearCanvas() {
            this.rectangles = [];
            this.redrawCanvas();
        }
    }
};
</script>

<style scoped>
canvas {
    width: 100%;
    border: 1px solid rgba(148, 163, 184, 0.24);
    border-radius: 22px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(241, 245, 249, 0.96) 100%);
    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.06);
    cursor: pointer;
}

button {
    margin-top: 10px;
    margin-right: 5px;
}

.context-menu {
    position: absolute;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(148, 163, 184, 0.18);
    border-radius: 16px;
    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.12);
    padding: 6px;
    list-style: none;
    z-index: 100;
}

.context-menu li {
    padding: 8px 12px;
    border-radius: 10px;
    cursor: pointer;
}

.context-menu li:hover {
    background: rgba(15, 118, 110, 0.08);
}
</style>
